export default "__VITE_ASSET__XApj$Bl4__"